import React, { useState } from "react";
import {
  Card,
  CardBody,
  Table,
  Input,
  Row,
  Col,
  Button,
} from "reactstrap";
import FeatherIcon from "feather-icons-react";

const cardShell = {
  background: "var(--vz-secondary-bg, #fff)",
  border: "1px solid var(--vz-border-color)",
  borderRadius: 10,
  boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
  overflow: "hidden",
};


const PlaybookManagerTable = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const playbooks = [
    {
      name: "Automated Threat Remediation for Phishing Alerts",
      triggerType: "Security Alert",
      lastUsed: "2023-10-28 14:30",
      status: "Active",
      linkedAlerts: 15,
    },
    {
      name: "User Account Lockout on Multiple Failed Logins",
      triggerType: "Login Failure",
      lastUsed: "2023-10-25 09:00",
      status: "Active",
      linkedAlerts: 8,
    },
    {
      name: "Data Exfiltration Detection and Blocking",
      triggerType: "Data Loss Prevention",
      lastUsed: "2023-10-24 18:45",
      status: "Draft",
      linkedAlerts: 0,
    },
    {
      name: "Suspicious Network Activity Isolation",
      triggerType: "Network Anomaly",
      lastUsed: "2023-10-23 11:20",
      status: "Active",
      linkedAlerts: 5,
    },
    {
      name: "Cloud Resource Misconfiguration Auto-Correction",
      triggerType: "Compliance Violation",
      lastUsed: "2023-10-22 07:10",
      status: "Draft",
      linkedAlerts: 9,
    },
    {
      name: "Endpoint Malware Containment and Scan",
      triggerType: "Malware Detection",
      lastUsed: "2023-10-21 16:00",
      status: "Active",
      linkedAlerts: 12,
    },
  ];

  const filteredPlaybooks = playbooks.filter((pb) =>
    pb.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const getBadgeColor = (status) => {
    switch (status) {
      case "Active": return {  color: "#27a517ff", border: "1px solid rgba(139, 170, 67, 0.3)" };
      case "Draft": return { color: "#FF5B00", border: "1px solid rgba(251, 191, 36, 0.3)" };
      default: return { color: "#374151", border: "1px solid #d1d5db" };
    }
  };

  return (
    <Card className="shadow-sm border-0" style={cardShell}>
      <CardBody>
        {/* Top Filters + Buttons */}
        <Row className="align-items-center mb-4">
          <Col className="d-flex flex-wrap align-items-center gap-2">
            <Input
              type="text"
              placeholder="Search playbooks..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ maxWidth: "180px", fontSize: "14px" }}
              bsSize="sm"
            />
            <Input type="select" style={{ maxWidth: "120px", fontSize: "14px" }} bsSize="sm">
              <option>All Status</option>
              <option>Active</option>
              <option>Draft</option>
            </Input>
            <Input type="select" style={{ maxWidth: "140px", fontSize: "14px" }} bsSize="sm">
              <option>All Alert Types</option>
              <option>Security Alert</option>
              <option>Login Failure</option>
              <option>Data Loss Prevention</option>
            </Input>
            <Input type="select" style={{ maxWidth: "110px", fontSize: "14px" }} bsSize="sm">
              <option>All Tags</option>
            </Input>

            <div className="ms-auto d-flex gap-2">
              <Button color="light" size="sm" className="d-flex align-items-center gap-1">
                <FeatherIcon icon="plus" size={13} /> Create
              </Button>
              <Button color="light" size="sm" className="d-flex align-items-center gap-1">
                <FeatherIcon icon="upload" size={13} /> Import
              </Button>
              <Button color="light" size="sm" className="d-flex align-items-center gap-1">
                <FeatherIcon icon="download" size={13} /> Export
              </Button>
              <Button color="danger" size="sm" className="d-flex align-items-center gap-1 btn btn-outline-danger">
                <FeatherIcon icon="trash-2" size={13} /> Disable
              </Button>
            </div>
          </Col>
        </Row>

        
        <div className="table-responsive">
          <Table bordered hover responsive className="align-middle mb-0">
            <thead className="table-light">
              <tr>
                <th>Playbook Name</th>
                <th>Trigger Type</th>
                <th>Last Used</th>
                <th>Status</th>
                <th>Linked Alerts</th>
                <th className="text-end">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredPlaybooks.map((pb, index) => (
                <tr key={index}>
                  <td>{pb.name}</td>
                  <td>{pb.triggerType}</td>
                  <td>{pb.lastUsed}</td>
                  <td>
                   <span className="badge rounded-pill" style={getBadgeColor(pb.status)} > {pb.status} </span>
                  </td>
                  <td>
                    <span className="text-primary fw-semibold">
                      {pb.linkedAlerts}
                    </span>
                  </td>
                  <td className="text-end">
                    <FeatherIcon
                      icon="more-horizontal"
                      size={16}
                      className="text-muted cursor-pointer"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </CardBody>
    </Card>
  );
};

export default PlaybookManagerTable;